// import router from 'vue-router'
import Vue from 'vue'


const actions = {

  checkIfBarcodeIsLocation: ({rootGetters}, payload) => {
    return rootGetters['locations/getLocation'](payload)
  },



}

export default actions

